import Vue from 'vue';
import { isURL } from '@/utils/validate';
import { ACCESS_TOKEN } from "@/store/mutation-types";
import { checkToken } from "@/api/api";
export const USER_AVATAR_PICTURE_ID = "AvatarPictureId";





// ---------------------------------------------------------------------------------------------------------------------------------------- com start
//---------------------------------------------------------------------------------------------------------------------- 字符串 start
/**  判断字符串是否为空 */
export function strIsEmpty(str){
    if(str === undefined || str === null || str.length === 0){
        return true;
    }else{
        return false;
    }
}

/**  验证 */
export function validateValue(pattern, value) {
    let result = true;
    // 6到16位数字
    if(pattern == 'n6-16'){
        result = new RegExp(/^\d{6,18}$/).test(value);
    }
    // 6到16位任意字符
    if(pattern == '*6-16'){
        result = new RegExp(/^.{6,16}$/).test(value);
    }
    // 6到18位字母
    if(pattern == 's6-18'){
        result = new RegExp(/^[a-z|A-Z]{6,18}$/).test(value);
    }
    // 网址
    if(pattern == 'url'){
        result = new RegExp(/^(?:([A-Za-z]+):)?(\/{0,3})([0-9.\-A-Za-z]+)(?::(\d+))?(?:\/([^?#]*))?(?:\?([^#]*))?(?:#(.*))?$/).test(value);
    }
    // 电子邮件
    if(pattern == 'e'){
        result = new RegExp(/^([\w]+\.*)([\w]+)@[\w]+\.\w{3}(\.\w{2}|)$/).test(value);
    }
    // 手机号码
    if(pattern == 'm'){
        result = new RegExp(/^1[3456789]\d{9}$/).test(value);
    }
    // 邮政编码
    if(pattern == 'p'){
        result = new RegExp(/^[1-9]\d{5}$/).test(value);
    }
    // 字母
    if(pattern == 's'){
        result = new RegExp(/^[A-Z|a-z]+$/).test(value);
    }
    // 数字
    if(pattern == 'n'){
        result = new RegExp(/^-?\d+(\.?\d+|\d?)$/).test(value);
    }
    // 整数
    if(pattern == 'z'){
        result = new RegExp(/^-?\d+$/).test(value);
        // /^[+]{0,1}(\d+)$/
    }
    // 非空
    if(pattern == "*"){
        result = new RegExp( /^.+$/).test(value);
    }
    // 金额
    if(pattern ==  'money'){
        result = new RegExp( /^(([1-9][0-9]*)|([0]\.\d{0,1}|[1-9][0-9]*\.\d{0,1}))$/).test(value);
    }

    return result;
}
//---------------------------------------------------------------------------------------------------------------------- 字符串 end


// --------------------------------------------------------------------------------------------------------------------- 时间 start
/** 格式化音视频时间 */
export function formatMediaTime(t){
    var h = parseInt(t/3600)
    h = h<10?'0'+h:h
    var m = parseInt(t%3600/60)
    m = m<10?'0'+m:m
    var s = parseInt(t%60)
    s = s<10?'0'+s:s
    return h+':'+m+':'+s
}
// --------------------------------------------------------------------------------------------------------------------- 时间 end


// --------------------------------------------------------------------------------------------------------------------- 其他 start
/**
 * 深度克隆对象、数组
 * @param obj 被克隆的对象
 * @return 克隆后的对象
 */
export function cloneObject(obj) {
    return JSON.parse(JSON.stringify(obj))
}

/**
 * 如果值不存在就 push 进数组，反之不处理
 * @param array 要操作的数据
 * @param value 要添加的值
 * @param key 可空，如果比较的是对象，可能存在地址不一样但值实际上是一样的情况，可以传此字段判断对象中唯一的字段，例如 id。不传则直接比较实际值
 * @returns {boolean} 成功 push 返回 true，不处理返回 false
 */
export function pushIfNotExist(array, value, key) {
    for (let item of array) {
        if (key && (item[key] === value[key])) {
            return false
        } else if (item === value) {
            return false
        }
    }
    array.push(value)
    return true
}

/**
 * 根据组件名获取父级
 * @param vm
 * @param name
 * @returns {Vue | null|null|Vue}
 */
export function getVmParentByName(vm, name) {
    let parent = vm.$parent
    if (parent && parent.$options) {
        if (parent.$options.name === name) {
            return parent
        } else {
            let res = getVmParentByName(parent, name)
            if (res) {
                return res
            }
        }
    }
    return null
}

/**
 * 简单实现防抖方法
 *
 * 防抖(debounce)函数在第一次触发给定的函数时，不立即执行函数，而是给出一个期限值(delay)，比如100ms。
 * 如果100ms内再次执行函数，就重新开始计时，直到计时结束后再真正执行函数。
 * 这样做的好处是如果短时间内大量触发同一事件，只会执行一次函数。
 *
 * @param fn 要防抖的函数
 * @param delay 防抖的毫秒数
 * @returns {Function}
 */
export function simpleDebounce(fn, delay = 100) {
    let timer = null
    return function () {
        let args = arguments
        if (timer) {
            clearTimeout(timer)
        }
        timer = setTimeout(() => {
            fn.apply(this, args)
        }, delay)
    }
}
// --------------------------------------------------------------------------------------------------------------------- 其他 end

// ---------------------------------------------------------------------------------------------------------------------------------------- com end









// ------------------------------------------------------------------------------------------------------------------------------------ web start

//---------------------------------------------------------------------------------------------------------------------- 路由 start
// 生成首页路由
export function generateIndexRouter(data) {
    if(window._CONFIG['moduleGroup'] == 1){
        let indexRouter = [{
            path: '/',
            name: 'index',
            component: resolve => require(['@/components/layouts/TabLayout'], resolve),
            meta: { title: '首页' },
            redirect: '/main/analysis',
            children: [
                ...generateChildRouters(data)
            ]
        },{
            "path": "*", "redirect": "/404", "hidden": true
        }]
        return indexRouter;
    }
    if(window._CONFIG['moduleGroup'] == 2){
        let indexRouter = [{
            path: '/',
            name: 'index',
            component: resolve => require(['@/components/layouts/PageLayout'], resolve),
            meta: { title: '首页' },
            redirect: '/web/index',
            children: [
                ...generateChildRouters(data)
            ]
        },{
            "path": "*", "redirect": "/404", "hidden": true
        }]
        return indexRouter;
    }
    return null;
}
// 生成嵌套路由（子路由）

function  generateChildRouters (data) {
    const routers = [];
    for (let item of data) {
        let component = "";
        if(item.component.indexOf("layouts")>=0){
            component = "components/"+item.component;
        }else{
            component = "views/"+item.component;
        }
        let URL = (item.meta.url|| '').replace(/{{([^}}]+)?}}/g, (s1, s2) => eval(s2)) // URL支持{{ window.xxx }}占位符变量
        if (isURL(URL)) {
            item.meta.url = URL;
        }
        let componentPath = resolve => require(['@/' + component+'.vue'], resolve);
        let menu =  {
            path: item.path,
            name: item.name,
            redirect:item.redirect,
            component: componentPath,
            hidden:item.hidden,
            meta: {
                title:item.meta.title ,
                icon: item.meta.icon,
                url:item.meta.url ,
                permissionList:item.meta.permissionList,
                keepAlive:item.meta.keepAlive,
                internalOrExternal:item.meta.internalOrExternal,
                componentName:item.meta.componentName
            }
        }
        if(item.alwaysShow){
            menu.alwaysShow = true;
            menu.redirect = menu.path;
        }
        if (item.children && item.children.length > 0) {
            menu.children = [...generateChildRouters( item.children)];
        }
        //判断是否生成路由
        if(item.route && item.route === '0'){
        }else{
            routers.push(menu);
        }
    }
    return routers
}
//---------------------------------------------------------------------------------------------------------------------- 路由 end

//---------------------------------------------------------------------------------------------------------------------- 页面 star
/**
 * 触发 window.resize
 */
export function triggerWindowResizeEvent() {
    let event = document.createEvent('HTMLEvents')
    event.initEvent('resize', true, true)
    event.eventType = 'message'
    window.dispatchEvent(event)
}
/**
 * 过滤对象中为空的属性
 */
export function filterObj(obj) {
    if (!(typeof obj == 'object')) {
        return;
    }
    for ( let key in obj) {
        if (obj.hasOwnProperty(key)
            && (obj[key] == null || obj[key] == undefined || obj[key] === '')) {
            delete obj[key];
        }
    }
    return obj;
}
//---------------------------------------------------------------------------------------------------------------------- 页面 end



// --------------------------------------------------------------------------------------------------------------------- 图片 start
/** 获取上传图片ID集（以逗号隔开） */
export function getUploadImageFileIds(fileList, fileStatus) {
    var fileIds = "";
    if(fileList.length > 0){
        for(let i=0; i<fileList.length; i++){
            if(fileList[i].status == fileStatus){
                if(fileIds == ""){
                    fileIds = fileList[i].uid;
                }else{
                    fileIds = fileIds + "," + fileList[i].uid;
                }
            }else {
                if (fileList[i].response != null) {
                    if (fileList[i].response.success === true) {
                        if (fileList[i].response.result.list != null && fileList[i].response.result.list.length > 0) {
                            if (fileIds == "") {
                                fileIds = fileList[i].response.result.list[0].picture_id;
                            } else {
                                fileIds = fileIds + "," + fileList[i].response.result.list[0].picture_id;
                            }
                        }
                    }
                }
            }
        }
    }
    return fileIds;
}

/** 获取上传图片ID集（以逗号隔开） */
export function getUploadFileIds(fileList, fileStatus) {
    var fileIds = "";
    if(fileList.length > 0){
        for(let i=0; i<fileList.length; i++){
            if(fileList[i].status == fileStatus){
                if(fileIds == ""){
                    fileIds = fileList[i].uid;
                }else{
                    fileIds = fileIds + "," + fileList[i].uid;
                }
            }else {
                if (fileList[i].response != null) {
                    if (fileList[i].response.success === true) {
                        if (fileList[i].response.result.list != null && fileList[i].response.result.list.length > 0) {
                            if (fileIds == "") {
                                fileIds = fileList[i].response.result.list[0].file_id;
                            } else {
                                fileIds = fileIds + "," + fileList[i].response.result.list[0].file_id;
                            }
                        }
                    }
                }
            }
        }
    }
    return fileIds;
}

/**  获取图片路径 */
export function getViewPictureUrl(baseUrl, token, pictureId, width, height) {
    let result = '';

    if(width != undefined && height != undefined){
        result = `${window._CONFIG['domianURL']}` + baseUrl + '/' + pictureId + '?width=' + width + '&height=' + height + '&client=1&token=' + token;
    }else{
        if(width == undefined && height == undefined){
            result = `${window._CONFIG['domianURL']}` + baseUrl + '/' + pictureId+ '?client=1&token=' + token;
        }else{
            // 只适配 height
            if(height != undefined){
                result = `${window._CONFIG['domianURL']}` + baseUrl + '/' + pictureId + '?height=' + height + '&client=1&token=' + token;
            }else if(width != undefined){
                result = `${window._CONFIG['domianURL']}` + baseUrl + '/' + pictureId + '?width=' + width + '&client=1&token=' + token;
            }else{
                result = `${window._CONFIG['domianURL']}` + baseUrl + '/' + pictureId + '?client=1&token=' + token;
            }
        }
    }

    return result;
}

/**  第一张图片URL */
export function getFirstPicturUrl(pictureIds, width, height) {
    //console.log('ids: ' + pictureIds);
    let id = '';
    if(!strIsEmpty(pictureIds)){
        let idsArr = pictureIds.split(',');
        if(idsArr != undefined && idsArr != null && idsArr.length > 0){
            id = idsArr[0];
        }
    }
    if(!strIsEmpty(id)){
        return getPictureUrl(id, width, height);
    }else{
        return '';
    }
}
/**  获取图片URL */
export function getPictureUrl(pictureId, width, height) {
    let result = '';
    let baseUrl = window._CONFIG['baseViewPictureURL'];
    let token = getToken();

    if(width != undefined && height != undefined){
        result = `${window._CONFIG['domianURL']}` + baseUrl + '/' + pictureId + '?width=' + width + '&height=' + height + '&client=1&token=' + token;
    }else{
        if(width == undefined && height == undefined){
            result = `${window._CONFIG['domianURL']}` + baseUrl + '/' + pictureId+ '?client=1&token=' + token;
        }else{
            // 只适配 height
            if(height != undefined){
                result = `${window._CONFIG['domianURL']}` + baseUrl + '/' + pictureId + '?height=' + height + '&client=1&token=' + token;
            }else if(width != undefined){
                result = `${window._CONFIG['domianURL']}` + baseUrl + '/' + pictureId + '?width=' + width + '&client=1&token=' + token;
            }else{
                result = `${window._CONFIG['domianURL']}` + baseUrl + '/' + pictureId + '?client=1&token=' + token;
            }
        }
    }
    return result;
}
// --------------------------------------------------------------------------------------------------------------------- 图片 end



// ------------------------------------------------------------------------------------------------------------------------------------ web end





/**
 * 获取Token
 * pRoot            根，即Vue Component的this
 * Redirect         是否重定向
 */
export function getToken(pRoot, pRedirect){
    let vToken = Vue.ls.get(ACCESS_TOKEN);
    //console.log('npm getToken fun, the token is: ' + vToken);
    if(vToken != null && vToken.length > 0){
        return vToken;
    }else{
        if(pRedirect){
            pRoot.$router.push({name:"Login", query:{}});
        }
        return "";
    }
}
/** 检查当前token是否过期 */
export function checkLocalToken(thisObj, callback){
    let token = Vue.ls.get(ACCESS_TOKEN);
    if(!strIsEmpty(token)) {
        let params = {};
        params.token = token;
        params.client = 1;
        checkToken(params).then((res) => {
            if (res.success) {
                if(res.code == 200){
                    // 0=无效   1=有效
                    let resultCheck = res.result - 0;
                    switch (resultCheck) {
                        case 0:
                            thisObj.$message.error("登陆已经过时，重新登陆...");
                            if(callback){
                                callback(false);
                            }
                            break;
                        case 1:
                            // nothing to do
                            if(callback){
                                callback(true);
                            }
                            break;
                    }
                }else{
                    thisObj.$message.error("登陆已经过时，重新登陆...");
                    if(callback){
                        callback();
                    }
                }
            } else {
                thisObj.$message.error("登陆已经过时，重新登陆...");
                if(callback){
                    callback(false);
                }
            }
        });
    }else{
        thisObj.$message.error("登陆已经过时，重新登陆...");
        if(callback){
            callback(false);
        }
    }
}

/**
 * 获取用户的头像图片ID号
 */
export function getAvatarPictureId(){
    let vPictureId = "";
    var vAvatarPictureIdLocal = Vue.ls.get(USER_AVATAR_PICTURE_ID);
    if(vAvatarPictureIdLocal == null || vAvatarPictureIdLocal == undefined){

    }else{
        vPictureId = vAvatarPictureIdLocal;
    }
    console.log('getAvatarPictureId , the pictureId=' + vPictureId);
    return vPictureId;
}
/**
 * 设置用户的头像的图片ID号
 */
export function setAvatarPictureId(pPictureId){
    console.log('setAvatarPictureId , the pictureId=' + pPictureId);
    Vue.ls.set(USER_AVATAR_PICTURE_ID, pPictureId, 7 * 24 * 60 * 60 * 1000);
}




/**  根据分类的List<TreeSelectModel>列表（树数据）生成Cascader级联组件使用的数据  */
export function getCategoryCascaderData(treeSelectModelList){
    let categoryList = [];
    if(treeSelectModelList != undefined && treeSelectModelList != null && treeSelectModelList.length > 0){
        for(let i=0; i<treeSelectModelList.length; i++){
            let c1 = {};
            let itemOne = treeSelectModelList[i];
            c1.value = itemOne.key;
            c1.label = itemOne.title;
            c1.children = [];
            if(itemOne.leaf == false && itemOne.children != undefined && itemOne.children != null && itemOne.children.length > 0){
                for(let j=0; j< itemOne.children.length; j++){
                    let c2 = {};
                    c2.value = itemOne.children[j].key;
                    c2.label = itemOne.children[j].title;
                    c1.children.push(c2);
                }
            }
            categoryList.push(c1);
        }
    }
    return categoryList;
}


// ------------------------------------------------------------------------------------- 时间 start
/** 获取秒数的时间字符串 */
export function getSecondTimeStr(value) {
    var secondTime = parseInt(value);// 秒
    var minuteTime = 0;// 分
    var hourTime = 0;// 小时
    if(secondTime > 60) {//如果秒数大于60，将秒数转换成整数
        //获取分钟，除以60取整数，得到整数分钟
        minuteTime = parseInt(secondTime / 60);
        //获取秒数，秒数取佘，得到整数秒数
        secondTime = parseInt(secondTime % 60);
        //如果分钟大于60，将分钟转换成小时
        if(minuteTime > 60) {
            //获取小时，获取分钟除以60，得到整数小时
            hourTime = parseInt(minuteTime / 60);
            //获取小时后取佘的分，获取分钟除以60取佘的分
            minuteTime = parseInt(minuteTime % 60);
        }
    }
    var result = "" + parseInt(secondTime) + "秒";

    if(minuteTime > 0) {
        result = "" + parseInt(minuteTime) + "分" + result;
    }
    if(hourTime > 0) {
        result = "" + parseInt(hourTime) + "小时" + result;
    }
    return result;
}

// ------------------------------------------------------------------------------------- 时间 end







// ---------------------------------------------------------------------------------------------------------------------  Area start
/**  初始化地区数据（省份列表） */
export function  initAreaOptions(areaList) {
    let result = [];
    if(areaList != undefined && areaList != null && areaList.length > 0){
        for(let i=0; i<areaList.length; i++){
            let item = {};
            item.value = areaList[i].id;
            item.label = areaList[i].shortName;
            if(areaList[i].childrenNum > 0){
                item.isLeaf = false;
            }else{
                item.isLeaf = true;
            }
            //console.log('provice item = ' + JSON.stringify(item));
            result.push(item);
        }
    }else{
        console.log('no.....');
    }
    return result;
}

// ---------------------------------------------------------------------------------------------------------------------  Area end







// ---------------------------------------------------------------------------------------------------------------------  二维码 start
/**  创建QRCode */
export  function createQrcode(moduleName, business, qrcodeValue) {
    let result = "";
    result = moduleName + "_" + business + "_" + qrcodeValue;
    return result;
}

// ---------------------------------------------------------------------------------------------------------------------  二维码 end






























































